// extracted by mini-css-extract-plugin
module.exports = {"pushed-back":"_2r4XvJbR","pushedBack":"_2r4XvJbR"};